var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.9375,
    height: 34.2188,
    rx: 5,
    fill: "#8DEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6052 13.1821V13.4641H22.9375V15.1155H20.4846C20.3372 16.0151 20.0557 16.7334 19.6402 17.2705C19.2381 17.7941 18.6617 18.1768 17.9111 18.4185C17.1605 18.6467 16.1887 18.7608 14.9957 18.7608V20.0297C14.9957 20.7681 15.1499 21.3522 15.4582 21.7818C15.7799 22.2115 16.316 22.4263 17.0666 22.4263C18.4338 22.4263 19.1174 21.6543 19.1174 20.1102H21.2285C21.2151 21.4663 20.8465 22.4934 20.1227 23.1916C19.4123 23.8764 18.3802 24.2188 17.0264 24.2188C15.6726 24.2188 14.6338 23.8428 13.91 23.0909C13.1996 22.339 12.8444 21.285 12.8444 19.929V17.1698C14.3323 17.1698 15.4247 17.1295 16.1217 17.049C16.8187 16.955 17.3347 16.767 17.6698 16.485C18.0183 16.2031 18.2462 15.7466 18.3534 15.1155H12V13.4641H18.4539V13.1821V11.6716H12V10H22.9375V11.6716H20.6052V13.1821Z",
    fill: "#5F1CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSales);
export default __webpack_public_path__ + "static/media/total_sales.432efbe04e8b66d18458d621f26f1167.svg";
export { ForwardRef as ReactComponent };